const config = {
    address: "Mládežnická 422, Neratovice",
    phone: "+420 777 889 312",
    email: "renata@maugliherna.cz"
  };
  
  export default config;